function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { deepClone } from "../util/object";
export var isBundle = function isBundle(item) {
  return _typeof(item) === "object" && "bundle" in item && item.bundle;
};
var getCurrency = function getCurrency(selection) {
  return (selection.totals.grandTotalPrice + "").split(/\s|&nbsp;/g).pop();
};
export var includeBundleDiscount = function includeBundleDiscount(selection) {
  var totalDiscount = Math.abs(selection.items.reduce(function (carry, item) {
    return carry + (isBundle(item) ? item.priceEachReductionAsNumber : 0);
  }, 0)) + Math.abs(selection.totals.totalDiscountPriceAsNumber || 0);
  return [totalDiscount, "-" + monify(totalDiscount, getCurrency(selection))];
};
export var getBeforeDiscountTotal = function getBeforeDiscountTotal(selection) {
  var beforeDiscountItemTotal = Math.abs(selection.items.reduce(function (carry, item) {
    return carry + item.priceEachBeforeDiscountAsNumber * item.quantity;
  }, 0));
  return [beforeDiscountItemTotal, monify(beforeDiscountItemTotal, getCurrency(selection))];
};
export var monify = function monify(amount, currency) {
  return moneyFormat(amount, 2, 3, " ", ".") + " ".concat(currency);
};
var moneyFormat = function moneyFormat(number, n, x, s, c) {
  var re = "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\D" : "$") + ")",
    num = number.toFixed(Math.max(0, ~~n));
  return (c ? num.replace(".", c) : num).replace(new RegExp(re, "g"), "$&" + (s || ","));
};

/**
 * Split bundles with more than 1 quantity to different line items
 * Use `priceReduction` from cache instead from Checkout API because the value changes for some reason
 */
export var splitBundles = function splitBundles(selectionItems, productCache) {
  var newItems = [];
  deepClone(selectionItems).forEach(function (item) {
    if (!isBundle(item)) {
      newItems.push(item);
      return;
    }
    var cache = productCache.items[item.product.product];
    if (cache) {
      item.priceEachReductionAsNumber = cache.price.priceReductionAsNumber;
    }
    if (isBundle(item) && item.quantity === 1) {
      newItems.push(item);
      return;
    }
    var counter = item.quantity;
    item.quantity = 1;
    while (counter-- > 0) {
      newItems.push(item);
    }
  });
  return newItems;
};


// WEBPACK FOOTER //
// ./scripts/components/bundles.js